<template>
<div class="c-competence-cards-page">
    <competence-cards-data-provider>
        <div slot-scope="dataProvider" class="o-width-limiter">
            <can i="manage" a="CompetenceCard">
                <div class="t-margin-bottom-m">
                    <router-link v-if="displayCreateButton" class="c-button c-button--primary" :to="`/create-competence-card/`">Lägg till medarbetare</router-link>
                    <router-link v-if="displayBatchAddCourseButton" class="c-button c-button--primary" :to="`/batch-competence-cards/`">Lägg till kurs för flera medarbetare</router-link>
                    <a v-if="displayBatchAddCompetenceButton" class="c-button c-button--primary" :href="competenceBatchUrl">Lägg till kompetens för flera medarbetare</a>
                    <a v-if="displayExportPdfsButton" class="c-button c-button--primary" :href="exportPdfsUrl">Skriv ut kompetenskort</a>
                </div>
                <div class="[ c-island c-island--large@lg ]  t-background-white-grey t-margin-bottom-s">
                    <competence-cards-filters></competence-cards-filters>
                    <div class="t-margin-top-s">
                        <competence-cards-list :competence-cards="dataProvider.competenceCardRows" :loading="dataProvider.loading"></competence-cards-list>
                    </div>
                </div>
            </can>
            <p v-if="!canManageCompetenceCards" class="t-text-style-beta t-margin-bottom-s t-margin-top-s">
                För att få tillgång till IN Kompetensverktyg behöver du vara administratör av tjänsten.</br>
                Kontakta tjänsteadministratören på ditt företag om du vill se din kompetensprofil eller skriva ut ett kompetenskort.
            </p>
        </div>
    </competence-cards-data-provider>
</div>
</template>

<script>
import CompetenceCardsDataProvider from '@/components/competences/competence-cards-data-provider/CompetenceCardsDataProvider.vue';
import CompetenceCardsFilters from '@/components/competences/competence-cards-filters/CompetenceCardsFilters.vue';
import CompetenceCardsList from '@/components/competences/competence-cards-list/CompetenceCardsList.vue';

export default {
    name: 'CompetenceCardsPage',
    components: {
        CompetenceCardsDataProvider,
        CompetenceCardsFilters,
        CompetenceCardsList
    },
    props: {
        apiUrl: {
            type: String,
            default: ''
        },
        exportPdfsUrl: {
            type: String,
            default: ''
        },
        competenceBatchUrl: {
            type: String,
            default: ''
        }
    },
    computed: {
        canManageCompetenceCards() {
            return this.$can('manage', 'CompetenceCard');
        },
        displayCreateButton() {
            return this.canManageCompetenceCards;
        },
        displayBatchAddCourseButton() {
            return this.canManageCompetenceCards;
        },
        displayExportPdfsButton() {
            return this.canManageCompetenceCards;
        },
        displayBatchAddCompetenceButton() {
            return this.canManageCompetenceCards;
        }
    },
    created() {
        this.$store.dispatch('competences/setAppData', {
            apiUrl: this.apiUrl,
            exportPdfsUrl: this.exportPdfsUrl,
            competenceBatchUrl: this.competenceBatchUrl
        }).then(() => {
            this.$store.dispatch('competences/setSettingsContext');
        });
    }
}
</script>
